// extracted by mini-css-extract-plugin
export default {"wrapper":"OU-z","firstToReview":"PU-z","productCards":"QU-z","productCard":"RU-z","stars":"SU-z","hidden":"TU-z"};